import React from 'react';
import './OrderConfirmation.css';

const formatPrice = (value) => {
    return Number(value).toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 0,
    });
};

function OrderConfirmation({ theme, onBackClick, orderDetails }) {
    if (!orderDetails) {
        return (
            <div className={`app ${theme}`}>
                <main>
                    <section className="confirmation-header-section">
                        <div className="confirmation-header">
                            <div>
                                <h1>Order Placed Successfully! (Probably)</h1>
                                <p className="confirmation-subtitle">No valid details were saved for this order.</p>
                            </div>
                            <button className="back-btn" onClick={onBackClick}>
                                Back to Shopping
                            </button>
                        </div>
                    </section>
                </main>
            </div>
        );
    }

    const { orderNumber, shippingMethod, placedAt, items, totalPrice } = orderDetails;
    const formattedDate = new Date(placedAt).toLocaleString('en-US', { dateStyle: 'medium', timeStyle: 'short' });

    const downloadInvoice = () => {
        const lines = [
            `Order Invoice - ${orderNumber}`,
            `Placed At: ${formattedDate}`,
            `Shipping Method: ${shippingMethod}`,
            '',
            'Items:',
            ...items.map((item) => `- ${item.name} x${item.quantity} @ ${formatPrice(item.price)} = ${formatPrice(Number(item.price) * Number(item.quantity))}`),
            '',
            `Total: ${formatPrice(totalPrice)}`,
            '',
            'Disclaimer: This is a parody website — no real orders are shipped.',
        ];
        const blob = new Blob([lines.join('\n')], { type: 'text/plain;charset=utf-8' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `invoice-${orderNumber}.txt`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };

    return (
        <div className={`app ${theme}`}>
            <main>
                <section className="confirmation-header-section">
                    <div className="confirmation-header">
                        <div>
                            <h1>Order Placed Successfully! (Probably)</h1>
                            <p className="confirmation-subtitle">Your foolishness has been registered</p>
                        </div>
                        <button className="back-btn" onClick={onBackClick}>
                            Back to Shopping
                        </button>
                    </div>
                </section>

                <section className="confirmation-content">
                    <div className="confirmation-card">
                        <div className="success-icon">✓</div>
                        <h2>Thank you for your order!</h2>

                        <div className="order-details">
                            <p className="order-number">
                                Your order number is <span className="order-id">#{orderNumber}</span>
                            </p>
                            <p className="order-date">
                                Order placed: <strong>{formattedDate}</strong>
                            </p>
                            <p className="chosen-partner">
                                Shipping method: <strong>{shippingMethod}</strong>
                            </p>
                        </div>

                        <div className="items-summary">
                            <h3>Order items</h3>
                            <div className="items-table">
                                <div className="items-row items-header">
                                    <span>Item</span>
                                    <span>Qty</span>
                                    <span>Unit</span>
                                    <span>Total</span>
                                </div>
                                {items.map((item) => (
                                    <div key={item.id} className="items-row">
                                        <span>{item.name}</span>
                                        <span>{item.quantity}</span>
                                        <span>{formatPrice(Number(item.price))}</span>
                                        <span>{formatPrice(Number(item.price) * Number(item.quantity))}</span>
                                    </div>
                                ))}
                            </div>
                            <div className="order-total">
                                <span>Total</span>
                                <strong>{formatPrice(totalPrice)}</strong>
                            </div>
                        </div>

                        <div className="order-message">
                            <p>
                                Your items have been shipped via <strong>{shippingMethod || 'Carrier Pigeon Express'}</strong>. Because our products are completely useless, they exist in a state of quantum superposition. They have both arrived at your house and never existed in the first place. Please check your porch, but do not look directly at it, or the wave function will collapse.
                            </p>
                            <p className="parody-reminder" style={{ marginTop: 12, fontWeight: 700, color: '#ffcc00' }}>
                                Note: This is a parody website — no real shipping will occur.
                            </p>
                        </div>

                        <div className="action-buttons">
                            <button className="refresh-btn" onClick={downloadInvoice}>
                                Download Invoice
                            </button>
                            <button className="refresh-btn continue-shopping-btn" onClick={onBackClick}>
                                Continue Shopping
                            </button>
                        </div>
                    </div>
                </section>
            </main>

            <footer className="footer">
                <p>© 2026 StupidDesigns.com. All rights reserved. Not that anyone actually wants them.</p>
            </footer>
        </div>
    );
}

export default OrderConfirmation;